<mat-card class="dashboard-card">
  <mat-card-header class="dashboard-card-header">
    <mat-card-title *ngIf="card.metricId; else noMetricId" class="dashboard-card-title">
      <a class="dashboard-card-link" (click)="goToMetrics(card.metricId)">
        <span>{{ card.title }}</span>
        <mat-icon>launch</mat-icon>
      </a>
    </mat-card-title>

    <ng-template #noMetricId>
      <mat-card-title class="dashboard-card-title">{{ card.title }}</mat-card-title>
    </ng-template>
  </mat-card-header>
  <mat-card-content class="dashboard-card-content">
    <span
      *ngIf="card.primaryMetric.value !== ''; else invisibleValue"
      class="dashboard-primary-value"
      [ngClass]="card.color"
      >{{ card.primaryMetric.value }}</span
    >
    <span class="dashboard-primary-label">{{ card.primaryMetric.label }}</span>

    <ng-template #invisibleValue>
      <span class="dashboard-primary-value">&nbsp;</span>
    </ng-template>
  </mat-card-content>
  <mat-card-footer class="dashboard-card-footer">
    <span class="dashboard-secondary-label">{{ card.secondaryMetric.label }} :</span>
    <span class="dashboard-secondary-value">&nbsp;{{ card.secondaryMetric.value }}</span>
  </mat-card-footer>
</mat-card>
